import { Text } from '#app/components/Primitives/Text.js';
import { type Theme } from '#app/theme/index.js';
import {
  TextInputPrefix,
  type TextInputSize,
  type TextInputVariant,
} from './types.js';
import { isValidElement } from 'react';
import { useTheme } from 'styled-components';

type PrefixProps<TVariant extends TextInputVariant> = {
  readonly disabled: boolean;
  readonly prefix?: TextInputPrefix;
  readonly size: TextInputSize;
  readonly variant: TVariant;
};

const getColor = ({
  disabled,
  theme,
}: {
  disabled: boolean;
  theme: Theme;
}): string => {
  if (disabled) {
    return theme.colorsV2.gray40;
  }

  return theme.colorsV2.gray60;
};

export const Prefix = <TVariant extends TextInputVariant>({
  disabled,
  prefix,
  size,
  variant,
}: PrefixProps<TVariant>) => {
  const theme = useTheme();

  if (variant === 'usd') {
    return (
      <Text
        color={getColor({ disabled, theme })}
        textStyle="subtitleRegular"
      >
        $
      </Text>
    );
  }

  if (prefix) {
    if (isValidElement(prefix)) {
      if (typeof prefix === 'string' || typeof prefix === 'number') {
        return (
          <Text
            color={getColor({ disabled, theme })}
            textStyle="subtitleRegular"
          >
            {prefix}
          </Text>
        );
      } else {
        return prefix;
      }
    }

    if (typeof prefix === 'object' && 'icon' in prefix) {
      const { icon: Icon, label } = prefix;

      return (
        <Icon
          aria-label={label}
          color={getColor({ disabled, theme })}
          size={size === 'small' ? 16 : 24}
        />
      );
    }
  }

  return null;
};
